export default __webpack_public_path__ + "static/media/task.494fa145.png";